import { render, staticRenderFns } from "./music.vue?vue&type=template&id=0f22ea16&scoped=true"
import script from "./music.vue?vue&type=script&lang=js"
export * from "./music.vue?vue&type=script&lang=js"
import style0 from "./music.vue?vue&type=style&index=0&id=0f22ea16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f22ea16",
  null
  
)

export default component.exports